if ($('#pg_config').length > 0) {

	$(".btn_menu_config").addClass('active');
	$(".btn_menu_config").closest('.dropdown').addClass('active');

}
